<script setup>
import { RouterView, useRoute } from 'vue-router'
import { computed, onMounted, watch } from 'vue'
import ConsentBanner from '@/components/ConsentBanner.vue'
import MobileHeader from '@/components/MobileHeader.vue'
import TabBar from '@/components/TabBar.vue'
import SideRail from '@/components/SideRail.vue'
import { useAuth } from '@/composables/useAuth'

// The login/auth-callback routes render their own minimal page and must
// NOT show the tab bar.
const route = useRoute()
const showChrome = computed(() => !['/login', '/auth/callback', '/review'].includes(route.path))
const { refresh } = useAuth()
let refreshedChrome = false

function refreshChromeAuth() {
  if (!showChrome.value || refreshedChrome) return
  refreshedChrome = true
  refresh().catch(() => {})
}

onMounted(refreshChromeAuth)
watch(showChrome, refreshChromeAuth)
</script>

<template>
  <div class="app-root" :class="{ 'app-root--chrome': showChrome }">
    <SideRail v-if="showChrome" />
    <MobileHeader v-if="showChrome" />
    <RouterView />
    <TabBar v-if="showChrome" />
    <ConsentBanner />
  </div>
</template>

<style>
/* ensure content can scroll past the fixed bottom tab bar on mobile */
@media (max-width: 767px) {
  .app-root--chrome main {
    padding-top: var(--space-md) !important;
    padding-bottom: 92px !important;
  }
}
@media (min-width: 768px) {
  .app-root--chrome main {
    margin-left: 232px !important;
  }
}
</style>
